import framework from './framework.js'
import tp from './tp.js'
import warehouse from './warehouse.js'
export default [...framework, ...tp, ...warehouse]


// WEBPACK FOOTER //
// ./src/config/routes/index.js